module.exports = __webpack_public_path__ + "static/chamber-building-a7bf11ddbc887fd6928eceac16f7ab82.jpg";